<template></template>
<script>
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
import { getWeChatAuthWechatUrl } from "@/api/mobile";
export default {
  data() {
    return {
      redirectUrl: null,
      state: null,
    };
  },
  methods: {
    getWeChatAuthWechatUrl() {
      this.state = generateUUID();
      this.redirectUrl = `https://www.aidajuan.com/mobile/landingPage`;
      getWeChatAuthWechatUrl({
        redirectUrl: this.redirectUrl,
        state: this.state,
      }).then((res) => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      });
    },
  },
  created() {
    this.getWeChatAuthWechatUrl();
  },
};
</script>